import { formatDateMonthDay, formatDateNumeric } from "../../../utils/format";

/** Month/day for dep cells/chips, with an em-dash for a missing date: "6/15"
 *  → "—" when null. */
export function fmtMonthDay(iso: string | null): string {
  return iso ? formatDateMonthDay(iso) : "—";
}

/** Numeric month/day/year for the Anchors board, with an em-dash for a missing
 *  date: "6/15/26" → "—" when null. */
export function fmtNumericDay(iso: string | null): string {
  return iso ? formatDateNumeric(iso) : "—";
}
